module.exports = __webpack_public_path__ + "img/gzlb- 1.4ef6b6bc.jpg";